import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorMessage } from '@model/error-message';
import { ConfigService } from '@services/webFeeder/config.service';
import { Constants } from '@utils/constants';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-error-screen',
  templateUrl: './error-screen.component.html',
})
export class ErrorScreenComponent implements OnInit {

  public errorMsg: ErrorMessage;
  dialog: MatDialog;
  hiddenButtonLogin =
    this._configService.getConfigWhitelabel() ? this._configService.getConfigWhitelabel().login.messageLogout.hiddenButtonLogin : false;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private _configService: ConfigService
  ) {
    this.errorMsg = new ErrorMessage(Constants.ERROR_ERROR_ICON, Constants.ERROR_ERROR_TITLE,
      Constants.ERROR_ERROR_TEXT, Constants.ERROR_ERROR_BUTTON, 'login', this.hiddenButtonLogin);
  }

  ngOnInit() {
    if (this.dialog) {
      this.dialog.closeAll();
    }
    this._configService.closeBillet(true);
    this.activeRoute.queryParams.subscribe(errorMsg => {
      if (errorMsg.type === 'invalid_caracter') {
        this.errorMsg = new ErrorMessage(Constants.ERROR_400_ICON,
          Constants.ERROR_400_TITLE, Constants.ERROR_400_TEXT,
          Constants.ERROR_400_BUTTON, 'login', this.hiddenButtonLogin);
      } else if (errorMsg.type && errorMsg.type.toString() === 'unauthorized') {
        this.errorMsg = new ErrorMessage(
          Constants.ERROR_403_ICON, Constants.ERROR_403_TITLE,
          Constants.ERROR_403_TEXT, Constants.ERROR_403_BUTTON, 'login',
          this.hiddenButtonLogin);
      } else if (errorMsg.title === undefined || errorMsg === null || errorMsg === undefined) {
        this.errorMsg = new ErrorMessage(
          Constants.ERROR_404_ICON, Constants.ERROR_404_TITLE,
          Constants.ERROR_404_TEXT, Constants.ERROR_404_BUTTON, 'login',
          this.hiddenButtonLogin);
      } else {
        this.errorMsg = new ErrorMessage(errorMsg.iconName, errorMsg.title, errorMsg.text,
          errorMsg.buttonText, errorMsg.route, this.hiddenButtonLogin);
      }
    });
    this._configService.deleteCookie();
  }

  onClick() {
    this._configService.REDIRECT_LOGIN();
  }

}
